/* eslint-disable react/prop-types */
import { Container, Grid, styled } from "@mui/material";
import CardAds from "../../components/CardAds";
import { GoogleBannerAds } from "../../components/GoogleAds";
import Page from '../../components/Page';
import useLocales from "../../hooks/useLocales";
import useSettings from "../../hooks/useSettings";
import Layout from '../../layouts';
import LicenseTypeItem from "../../sections/practicalExam/LicenseTypeItem";
import PracticeWelcome from "../../sections/practicalExam/PracticeWelcome";
import { findLicenseTypesAPI } from "../../service/gplx.licenseType.service";

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
  },
  paddingBottom: theme.spacing(10),
}));

PracticalExam.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function PracticalExam({ licenseTypes }) {
  const { translate } = useLocales();
  const { themeStretch } = useSettings();

  return (
    <Page title={translate('practice.title')} description={translate('practice.description')}>
      <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
        <RootStyle>
          <Banner />
          <Grid container spacing={2} >
            {licenseTypes.map(item => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <LicenseTypeItem item={item} />
              </Grid>
            ))}
            <Grid item xs={12} sm={4}>
              <GoogleBannerAds />
            </Grid>
          </Grid>
        </RootStyle>
      </Container>
    </Page >
  );
}

function Banner() {
  return (<Grid container spacing={3} mb={5}>
    <Grid item xs={12} md={8}>
      <PracticeWelcome />
    </Grid>
    <Grid item xs={12} md={4}>
      <CardAds />
    </Grid>
  </Grid>);
}

export async function getStaticProps() {
  const search = { page: 0, size: 12, value: '%%', orders: [{ order: 'asc', property: 'orderNo', },], };

  const { code, data: licenseTypes } = await findLicenseTypesAPI(search);

  if (code !== "200") {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      licenseTypes
    },
  };
}